import { ExperienceButton } from "./CTA";

export const StickyCTA = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-black/70 px-4 py-3 backdrop-blur-xl md:hidden"
    data-testid="sticky-mobile-cta"
  >
    <div className="flex items-center justify-between gap-3">
      <p className="font-mono text-[10px] uppercase leading-tight tracking-[0.2em] text-zinc-300">
        Your first session<br />is on us
      </p>
      <ExperienceButton id="sticky-cta-claim" className="px-5 py-3" />
    </div>
  </div>
);
